module.exports = __webpack_public_path__ + "static/media/Sanjuan.55a6ca0a.svg";